// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"d96f19a2","589":"79d25dbc","912":"79d25dbc"}[chunkId] + ".chunk.css";
};